module.exports = __webpack_public_path__ + "img/enlightenment-course-7.c2ab0c81.png";